import { Inserter } from "nystem-components";

const RouterOutlet = ({ model }) => <Inserter match={model.match} source={model.source} className={model.className} />;

export default RouterOutlet;
